import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, Button, Collapse, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';

interface ExtraDetailsSectionProps {
  stepsToReproduce: string;
  expectedResult: string;
  actualResult: string;
  onStepsChange: (val: string) => void;
  onExpectedChange: (val: string) => void;
  onActualChange: (val: string) => void;
  disabled?: boolean;
}

export const ExtraDetailsSection: React.FC<ExtraDetailsSectionProps> = ({
  stepsToReproduce,
  expectedResult,
  actualResult,
  onStepsChange,
  onExpectedChange,
  onActualChange,
  disabled,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box>
      <Button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        sx={{
          p: 0,
          color: '#0F9A00',
          fontSize: '0.78rem',
          fontWeight: 600,
          textTransform: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' },
        }}
      >
        {isOpen ? (
          <>
            <KeyboardArrowUpIcon fontSize="small" /> Hide extra detail
          </>
        ) : (
          <>
            <KeyboardArrowDownIcon fontSize="small" /> Add more detail (optional)
          </>
        )}
      </Button>

      <Collapse in={isOpen} unmountOnExit>
        <Box
          sx={{
            mt: 1,
            p: 1.5,
            borderRadius: '8px',
            border: '1px dashed #cbd5e1',
            display: 'flex',
            flexDirection: 'column',
            gap: 1.25,
            backgroundColor: '#fbfcfd',
          }}
        >
          <Box>
            <Typography variant="caption" sx={{ fontWeight: 500, color: '#4b5563', display: 'block', mb: 0.25 }}>
              Steps to reproduce
            </Typography>
            <TextField
              size="small"
              fullWidth
              multiline
              rows={2}
              placeholder={'1. Go to…\n2. Click…'}
              value={stepsToReproduce}
              onChange={(e) => onStepsChange(e.target.value)}
              disabled={disabled}
              inputProps={{ style: { fontSize: '0.8rem' } }}
            />
          </Box>

          <Box>
            <Typography variant="caption" sx={{ fontWeight: 500, color: '#4b5563', display: 'block', mb: 0.25 }}>
              Expected result
            </Typography>
            <TextField
              size="small"
              fullWidth
              multiline
              rows={2}
              placeholder="What should have happened…"
              value={expectedResult}
              onChange={(e) => onExpectedChange(e.target.value)}
              disabled={disabled}
              inputProps={{ style: { fontSize: '0.8rem' } }}
            />
          </Box>

          <Box>
            <Typography variant="caption" sx={{ fontWeight: 500, color: '#4b5563', display: 'block', mb: 0.25 }}>
              Actual result
            </Typography>
            <TextField
              size="small"
              fullWidth
              multiline
              rows={2}
              placeholder="What actually occurred instead…"
              value={actualResult}
              onChange={(e) => onActualChange(e.target.value)}
              disabled={disabled}
              inputProps={{ style: { fontSize: '0.8rem' } }}
            />
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
};
